import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';
import {Subject} from 'rxjs';
import {ModalComponent} from '@components/modal/modal.component';
import {SpecialistsProvider} from '@providers/specialists/specialists.provider';
import {FormControl} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';

enum ViewStatus {
    select = 1,
    create,
    edit,
}

@Component({
    selector: 'app-specialist-chose',
    templateUrl: 'specialist-chose-modal.component.html'
})

export class SpecialistChoseModalComponent implements OnInit, OnDestroy {
    public specialist: SpecialistViewInterface;

    /**
     * Выбранный Id специалиста.
     * Нужен, чтобы на него подписался родительский компонент
     */
    public chosenId$ = new Subject<number>();

    /**
     * Что отображать в модальном окне?
     * Создание, выбор или редактирование
     */
    public viewStatus: ViewStatus = ViewStatus.select;
    public viewStatuses = ViewStatus;

    /**
     * Значения специалистов для селекта выбора
     */
    public specialistsSelectValues: {id: number, title: string}[] = [];

    /**
     * Контрол для выбора специалиста
     */
    public specialistSelect = new FormControl('');

    /**
     * Выбранный в селекте специалист
     */
    public selectedSpecialist: SpecialistViewInterface;

    /**
     * Якорь на dom элемент, к которому нужно подскроллить во время редактирования
     */
    public domElementAnchor: string;

    @ViewChild(ModalComponent) private modal: ModalComponent;

    private destroyed$ = new Subject();

    constructor(
        private specialistsProvider: SpecialistsProvider,
    ) {
    }

    ngOnInit() {
        /**
         * Подготавливаем значения для селекта
         */
        this.specialistsSelectValues = this.specialistsProvider.notFired$.getValue().map(item => {
            return {
                id: item.id,
                title: item.full_name
            };
        });

        /**
         * Обновляем выбранного в зависимости от значения селекта
         */
        this.specialistSelect.valueChanges.pipe(
            takeUntil(this.destroyed$),
        ).subscribe((id) => {
            this.selectedSpecialist = this.specialistsProvider.getById(+id);
        });

        this.specialistSelect.updateValueAndValidity();
    }

    setViewStatus(status: ViewStatus, domElementId?: string) {
        this.viewStatus = status;
        this.domElementAnchor = domElementId;
    }

    /**
     *
     * @param id - выбранный по дефолту сотрудник
     */
    show(id?: number) {
        this.modal.open();
        this.specialistSelect.patchValue(id || '');
    }

    onModalClose() {
        this.chosenId$.next(null);
    }

    selectSpecialist(id: number) {
        if (!id) {
            return;
        }
        this.chosenId$.next(id);
    }

    ngOnDestroy() {
        this.destroyed$.next(true);
    }
}

